export class ApiConsumer {
  public id: string;
  public name: string;
  public enabled: boolean;
  public webhookUrl: string;
  public webhookVersion: string;
  public apiKey: string;
  public secondaryApiKey: string;
  public webhooksEnabled: boolean;
  public webhooksEnabledPatient: boolean;
  public webhooksEnabledVisit: boolean;
  public webhooksEnabledExpense: boolean;
  public webhooksEnabledTrip: boolean;
  public firstPartyConsumer: boolean;
  public oneTimePasswordEnabled: boolean;

  constructor(init?: Partial<ApiConsumer>) {
    Object.assign(this, init);
  }
}
